import { Image, SimpleGrid } from '@chakra-ui/react';

import { AdminPaymentProofDisplayItem } from '../../types/payment-proof-ocr';
import { PaymentProofOcrCard } from './payment-proof-ocr-card';
import { PaymentProofPdfPreview } from './payment-proof-pdf-preview';

interface PaymentProofDisplayGridProps {
  items: AdminPaymentProofDisplayItem[];
}

export function PaymentProofDisplayGrid({
  items,
}: PaymentProofDisplayGridProps) {
  return (
    <SimpleGrid
      data-testid="payment-proof-display-grid"
      columns={{ base: 1, xl: 2 }}
      columnGap={6}
      rowGap={{ base: 10, xl: 12 }}
      alignItems="flex-start"
      sx={{
        '@media print': {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          columnGap: '12px',
          rowGap: '16px',
        },
      }}
    >
      {items.map((displayItem, index) => {
        if (displayItem.kind === 'ocr') {
          return (
            <PaymentProofOcrCard
              key={displayItem.item.id}
              item={displayItem.item}
            />
          );
        }

        if (displayItem.kind === 'pdf') {
          return (
            <PaymentProofPdfPreview
              key={displayItem.id}
              index={index}
              url={displayItem.url}
            />
          );
        }

        return (
          <Image
            key={displayItem.id}
            src={displayItem.url}
            alt={`Bukti Pembayaran-${index}`}
            data-testid="payment-proof-legacy-preview"
            w="100%"
            border="1px solid"
            borderColor="#E2E8F0"
            borderRadius="8px"
            objectFit="contain"
            bg="white"
            loading="lazy"
            sx={{
              breakInside: 'avoid',
              pageBreakInside: 'avoid',
            }}
          />
        );
      })}
    </SimpleGrid>
  );
}
